module.exports = __webpack_public_path__ + "cba9f7cd1856c29ac6f57aa7ae62a9a5.jpg";